import React from 'react';
import { ItemCheckbox, Item } from '../../../styles';
import ItemIconElement from '../../icon';
import { Checkbox } from '@acko-tech/building-blocks.ui.input';

const Index = ({ item, checked, handleUpdate }) => {
  return (
    <ItemCheckbox key={item?.code} onClick={() => handleUpdate(item)}>
      <Item>
        <ItemIconElement item={item} />
        <div>{item?.name}</div>
      </Item>
      <Checkbox
        className="item-checkbox"
        onChange={() => {}}
        checked={checked}
      />
    </ItemCheckbox>
  );
};

export default Index;
